const fnolTypeAuto = { value: 1, text: 'Auto' };
const fnolTypeCommercialAuto = { value: 2, text: 'Commercial-Auto' };
const fnolTypeLiability = { value: 3, text: 'Liability' };
const fnolTypeProperty = { value: 4, text: 'Property' };

export { fnolTypeAuto, fnolTypeCommercialAuto, fnolTypeLiability, fnolTypeProperty }